module.exports = __webpack_public_path__ + "img/exmple-4.cbb1db34.png";